/**
 * Authentication configuration
 * Obfuscated to make it harder to discover via source code search
 */

// Obfuscated admin header name - reconstructed at runtime
const _h = ['X', '-', 'A', 'd', 'm', 'i', 'n', '-', 'P', 'a', 's', 's'];
export const ADMIN_HEADER = _h.join('');

// Obfuscated localStorage key - reconstructed at runtime  
const _k = ['a', 'd', 'm', 'i', 'n', '-', 'p', 'a', 's', 's'];
export const ADMIN_STORAGE_KEY = _k.join('');

/**
 * Gets the admin header name
 * Use this instead of hardcoding 'X-Admin-Pass'
 */
export function getAdminHeader(): string {
    return ADMIN_HEADER;
}

/**
 * Gets the admin storage key
 * Use this instead of hardcoding 'admin-pass'
 */
export function getAdminStorageKey(): string {
    return ADMIN_STORAGE_KEY;
}

/**
 * Gets the admin password from storage
 */
export function getAdminPassword(): string | null {
    try {
        return localStorage.getItem(ADMIN_STORAGE_KEY);
    } catch {
        return null;
    }
}

/**
 * Sets the admin password in storage
 */
export function setAdminPassword(password: string): void {
    try {
        localStorage.setItem(ADMIN_STORAGE_KEY, password);
    } catch (error) {
        console.error('Failed to save admin password:', error);
    }
}

/**
 * Removes the admin password from storage
 */
export function clearAdminPassword(): void {
    try {
        localStorage.removeItem(ADMIN_STORAGE_KEY);
    } catch (error) {
        console.error('Failed to clear admin password:', error);
    }
}

/**
 * Creates headers with admin authentication
 */
export function createAdminHeaders(additionalHeaders?: Record<string, string>): Record<string, string> {
    const password = getAdminPassword();
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...additionalHeaders
    };

    if (password) {
        headers[ADMIN_HEADER] = password;
    }

    return headers;
}
